export default __webpack_public_path__ + "b5cefc7f141ca25db53a9d4775793685.png";